import React from 'react';

const InputField = ({ 
    label, 
    type = 'text', 
    name, 
    placeholder, 
    value, 
    onChange, 
    error, 
    options = [], 
    checked, 
    classes = "py-3 px-4 w-full border-gray-200 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600",
    ...props 
  }) => {

    // Class Handling
    const baseClass = `${classes} ${error ? 'border-red-500 border rounded-lg bg-red-50' : ''}`;
    const labelClass = `block text-md leading-6 text-gray-900 ${error ? 'text-red-500 font-bold' : 'font-medium'}`;
    const booleanClass = "peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800";
    const radioClass = "h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600";

    const inputClass = {
      text: baseClass,
      select: baseClass,
      boolean: booleanClass,
      radio: radioClass,
    }[type] || baseClass;

    // Common Layout Wrapper
    const renderLabel = () => <label htmlFor={name} className={labelClass}>{label}</label>;

    // Render Different Input Types
    switch (type) {
      case 'select':
        return (
          <div className="input_wrapp">
            {renderLabel()}
            <select
              id={name}
              value={value}
              onChange={onChange}
              name={name}
              className={inputClass}
              {...props}
            >
              <option disabled value="">Select {label}</option>
              {options.map((option, index) => (
                <option key={index} value={option}>{option}</option>
              ))}
            </select>
          </div>
        );

      case 'boolean':
        return (
          <div className="input_wrapp">
            <div className="inline-flex items-center">
              <input 
                type="checkbox"
                className={inputClass}
                checked={checked}
                id={name}
                name={name}
                onChange={onChange}
                {...props}
              />
              <span className="ml-4 font-medium">{renderLabel()}</span>
            </div>
          </div>
        );

      case 'radio':
        return (
          <div className="input_wrapp">
            {renderLabel()}
            <div className={`radio-group grid ${props.inRow ? 'grid-cols-4' : 'grid-cols-1'}`}>
              {options.map((option, index) => (
                <div key={index}>
                  <label className="radio-label">
                    <input 
                      type="radio" 
                      name={name} 
                      value={option} 
                      checked={value === option} 
                      onChange={onChange} 
                      className={inputClass}
                    />
                    <span className="pl-2 text-sm">{option}</span>
                  </label>
                </div>
              ))}
            </div>
          </div>
        );

      default:
        return (
          <div className="input_wrapp">
            {renderLabel()}
            <input
              type={type}
              id={name}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              name={name}
              className={inputClass}
              {...props}
            />
          </div>
        );
    }
};

export default InputField;
